import { IndicatorBase, IndicatorSelection, Selection } from "types";

export function addIndicatorToSelection(
  selection: Selection,
  indicator: IndicatorBase
): Selection {
  return {
    properties: [...selection.properties],
    indicators: [
      {
        indicatorId: indicator.id,
        layerId: null,
        opacity: indicator.opacity,
        active: indicator.isDefaultActive,
        order: selection.indicators.length,
      },
      ...selection.indicators,
    ],
  };
}

export function removeIndicatorFromSelection(
  selection: Selection,
  indicator: IndicatorBase
): Selection {
  return {
    properties: [...selection.properties],
    indicators: selection.indicators.filter(
      (item) => item.indicatorId !== indicator.id
    ),
  };
}

export function updateSelectionIndicators(
  selection: Selection,
  update: IndicatorSelection
): Selection {
  const updatedIndicators = selection.indicators.map((selectionItem) => {
    if (selectionItem.indicatorId === update.indicatorId) return { ...update };
    else return { ...selectionItem };
  });

  return {
    ...selection,
    indicators: updatedIndicators,
  };
}
